export default [
  {
    path: '/country',
    name: 'country',
    component: () => import('@/views/menu/public/country.vue'),
    meta: {
      pageTitle: 'مدیریت کشور ها',
      action: 'show',
      resource: 'CountryManager',
    },
  },
  {
    path: '/state',
    name: 'state',
    component: () => import('@/views/menu/public/state.vue'),
    meta: {
      pageTitle: 'مدیریت استان ها',
      action: 'show',
      resource: 'StateManager',
    },
  },
  {
    path: '/city',
    name: 'city',
    component: () => import('@/views/menu/public/city.vue'),
    meta: {
      pageTitle: 'مدیریت شهرها',
      action: 'show',
      resource: 'CityManager',
    },
  },
  {
    path: '/customs',
    name: 'customs',
    component: () => import('@/views/menu/customs/customs.vue'),
    meta: {
      pageTitle: 'مدیریت گمرک ها',
      action: 'show',
      resource: 'CustomsManager',
    },
  },
  {
    path: '/customs/details',
    name: 'addcustoms',
    component: () => import('@/views/menu/customs/customsdetails.vue'),
    meta: {
      pageTitle: 'ایجاد گمرک',
      action: 'show',
      resource: 'CustomsManager',
    },
  },
  {
    path: '/customs/details/:id',
    name: 'updatecustoms',
    component: () => import('@/views/menu/customs/customsdetails.vue'),
    meta: {
      pageTitle: 'ویرایش گمرک',
      action: 'show',
      resource: 'CustomsManager',
    },
  },
  {
    path: '/customstype',
    name: 'customstype',
    component: () => import('@/views/menu/customs/customstype.vue'),
    meta: {
      pageTitle: 'مدیریت نوع های گمرک',
      action: 'show',
      resource: 'CustomsTypeManager',
    },
  },
  {
    path: '/customsgood',
    name: 'customsgood',
    component: () => import('@/views/menu/customs/customsgood.vue'),
    meta: {
      pageTitle: 'مدیریت کالاهای گمرکی',
      action: 'show',
      resource: 'CustomsGoodManager',
    },
  },
  {
    path: '/customsprocedure',
    name: 'customsprocedure',
    component: () => import('@/views/menu/customs/customsprocedure.vue'),
    meta: {
      pageTitle: 'مدیریت رویه های گمرکی',
      action: 'show',
      resource: 'CustomsProcedureManager',
    },
  },
  {
    path: '/tircarnet',
    name: 'tircarnet',
    component: () => import('@/views/menu/customs/tircarnet.vue'),
    meta: {
      pageTitle: 'مدیریت کارنه تیر',
      action: 'show',
      resource: 'TirCarnetManager',
    },
  },
]
